import { render } from "./ContestCard.vue?vue&type=template&id=53cb8d10&scoped=true"
import script from "./ContestCard.vue?vue&type=script&lang=js"
export * from "./ContestCard.vue?vue&type=script&lang=js"

import "./ContestCard.vue?vue&type=style&index=0&id=53cb8d10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cb8d10"]])

export default __exports__